import {createReducer} from "typesafe-actions";
import {SET_DEBUG_MODE} from "../actions";

export const debugMode = createReducer(false).handleAction(SET_DEBUG_MODE, (state, action) => action.payload);